import Layout from '../views/layout/Layout'
import RouteView from '../views/layout/RouteView'

const operatingDataRoutes = {
  path: '/operatingData',
  alias: '/finance/operatingData',
  component: Layout,
  name: 'operatingDataManagement',
  redirect: '/operatingData/overview/analysis',
  defaultPath: '/operatingData/overview/analysis',
  meta: {
    title: '经营数据',
    icon: 'businessAnalysis',
    alwaysShow: true
  },
  children: [
    {
      path: 'overview',
      name: 'operatingAnalysisManagement',
      sort: 0,
      component: RouteView,
      meta: { title: '经营分析', icon: 'businessAnalysis', requireVisibleChild: true },
      children: [
        {
          path: 'analysis',
          alias: ['/operatingData/analysis', '/finance/operatingData/analysis'],
          name: 'operatingAnalysis',
          morePath: '/operatingData/overview/analysis',
          component: () => import('@/views/operatingData/analysis/index'),
          meta: { title: '经营总览', icon: 'businessAnalysis' }
        }
      ]
    },
    {
      path: 'settlement',
      name: 'operatingCalculationManagement',
      sort: 1,
      component: RouteView,
      meta: { title: '核算与测算', icon: 'financialSettlement', requireVisibleChild: true },
      children: [
        {
          path: 'allocations',
          alias: ['/operatingData/allocations', '/finance/operatingData/allocations'],
          name: 'operatingAllocation',
          morePath: '/operatingData/settlement/allocations',
          component: () => import('@/views/operatingData/allocations/index'),
          meta: { title: '月度归属核算', icon: 'adversiter-consume-list' }
        },
        {
          path: 'redPacket',
          alias: ['/operatingData/redPacket', '/finance/operatingData/redPacket'],
          name: 'operatingRedPacket',
          morePath: '/operatingData/settlement/redPacket',
          component: () => import('@/views/operatingData/redPacket/index'),
          meta: { title: '年度红包', icon: 'chart_bar_fill' }
        },
        {
          path: 'rebateCalculator',
          alias: ['/operatingData/rebateCalculator', '/finance/operatingData/rebateCalculator'],
          name: 'operatingRebateCalculator',
          morePath: '/operatingData/settlement/rebateCalculator',
          component: () => import('@/views/operatingData/rebateCalculator/index'),
          meta: { title: '返点测算', icon: 'financialSettlement' }
        }
      ]
    },
    {
      path: 'incentives',
      name: 'operatingIncentiveManagement',
      sort: 2,
      component: RouteView,
      meta: { title: '激励管理', icon: 'product-list', requireVisibleChild: true },
      children: [
        {
          path: 'campaigns',
          alias: ['/operatingData/campaigns', '/finance/operatingData/campaigns'],
          name: 'incentiveCampaign',
          morePath: '/operatingData/incentives/campaigns',
          component: () => import('@/views/operatingData/campaigns/index'),
          meta: { title: '激励活动', icon: 'product-list' }
        },
        {
          path: 'progress',
          alias: ['/operatingData/progress', '/finance/operatingData/progress'],
          name: 'incentiveProgress',
          morePath: '/operatingData/incentives/progress',
          component: () => import('@/views/operatingData/progress/index'),
          meta: { title: '激励进度', icon: 'chart_bar_fill' }
        },
        {
          path: 'results',
          alias: ['/operatingData/results', '/finance/operatingData/results'],
          name: 'incentiveResult',
          morePath: '/operatingData/incentives/results',
          component: () => import('@/views/operatingData/results/index'),
          meta: { title: '激励测算明细', icon: 'customer-list' }
        },
        {
          path: 'settlements',
          alias: ['/operatingData/settlements', '/finance/operatingData/settlements'],
          name: 'incentiveSettlement',
          morePath: '/operatingData/incentives/settlements',
          component: () => import('@/views/operatingData/settlements/index'),
          meta: { title: '激励返点表', icon: 'financialSettlement' }
        }
      ]
    },
    {
      path: 'configuration',
      name: 'operatingRuleDataManagement',
      sort: 3,
      component: RouteView,
      meta: { title: '规则与数据', icon: 'product-list', requireVisibleChild: true },
      children: [
        {
          path: 'policies',
          alias: ['/operatingData/policies', '/finance/operatingData/policies'],
          name: 'operatingPolicyRules',
          morePath: '/operatingData/configuration/policies',
          component: () => import('@/views/operatingData/policies/index'),
          meta: { title: '政策规则', icon: 'product-list' }
        },
        {
          path: 'imports',
          alias: ['/operatingData/imports', '/finance/operatingData/imports'],
          name: 'operatingDataImport',
          morePath: '/operatingData/configuration/imports',
          component: () => import('@/views/operatingData/imports/index'),
          meta: { title: '数据导入', icon: 'customer-list' }
        }
      ]
    }
  ]
}

export default operatingDataRoutes



// WEBPACK FOOTER //
// ./src/router/operating-data.js